import { defineClassNames } from '../utils/defineClassNames';

export const classes = defineClassNames('popover-menu', {
  popoverContent: { states: ['withWidth'] },
  listItem: {},
});
